import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import { FieldInterface } from 'common/types/entities/field-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createContactUsField(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
  slug?: FieldSlugEnum,
) {
  const field: FieldInterface = {
    ...generateBaseEntity(
      EntityTypeEnum.ContactUsField,
      parentId,
      masterBlockId,
    ),
    optional: false,
    textAlign: 'left',
    fontSize: 18,
    slug: FieldSlugEnum.Email,
    backgroundColor: 'rgba(241, 244, 248, 1)',
    padding: {
      paddingTop: 20,
      paddingRight: 10,
      paddingBottom: 20,
      paddingLeft: 10,
    },
    border: {
      radius: 3,
      style: BorderStyleEnum.none,
    },
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 25,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 10,
      marginLeft: 0,
    },
  }

  if (slug) {
    field.slug = slug
  }

  return field
}
